import {
  Anchor,
  AppShellFooter,
  AppShellMain,
  AppShell as BaseAppShell,
} from "@mantine/core"
import { Crisp } from "crisp-sdk-web"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router-dom"

import classes from "~/assets/css/SuppplierHeader.module.css"
import { SupplierAppHeader } from "~/components/layout/SupplierAppHeader"

export const SupplierAppShell = () => {
  const { t } = useTranslation()

  useEffect(() => {
    if (
      import.meta.env.MODE != "development" &&
      import.meta.env.VITE_CRISP_WEBSITE_ID
    ) {
      Crisp.configure(import.meta.env.VITE_CRISP_WEBSITE_ID)
    }
  }, [])

  return (
    <BaseAppShell
      padding={0}
      layout="alt"
      header={{ height: "var(--mantine-supplier-header-height)" }}
    >
      <SupplierAppHeader />
      <AppShellMain>
        <Outlet />
      </AppShellMain>
      <AppShellFooter className={classes["supplier-footer"]} p="sm">
        <Anchor
          href="https://www.traceforgood.com/privacy-policy"
          target="blank"
          fz="xs"
        >
          {t("supplier.footer.privacyPolicy")}
        </Anchor>
      </AppShellFooter>
    </BaseAppShell>
  )
}
